import instance from "../utils/network";

export function getImagePopup(): Promise<ImagePopup[]> {
  return instance.get("/nest/image-popup");
}

export interface ImagePopup {
  id: number;
  imagePath: string;
  buttonText: string;
  buttonUrl: string;
}
